import { createFeature, createReducer, on } from '@ngrx/store';
import { IClientPostbacks } from '../../_common/_interfaces/IClientPostbacks';
import { PostbackActions } from './postback.actions';

export const postbackFeatureKey = 'postback';

export interface PostbackState {
  data: IClientPostbacks | null;
  loading: boolean;
  error: any;
}

const initialState: PostbackState = {
  data: null,
  loading: false,
  error: null,
};

export const postbackFeature = createFeature({
  name: postbackFeatureKey,
  reducer: createReducer(
    initialState,

    on(PostbackActions.loadClientPostbacks, PostbackActions.saveClientPostbacks, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),

    on(PostbackActions.loadClientPostbacksSuccess, (state, { data }) => ({
      ...state,
      data,
      loading: false,
      error: null,
    })),
    on(PostbackActions.saveClientPostbacksSuccess, (state, { data }) => ({
      ...state,
      data, // reflect latest saved data
      loading: false,
      error: null,
    })),

    on(
      PostbackActions.loadClientPostbacksFailure,
      PostbackActions.saveClientPostbacksFailure,
      (state, { error }) => ({
        ...state,
        loading: false,
        error,
      })
    )
  ),
});
